var map = {
	"./DSC05000_10_Zuschnitt_Oben_Unten.jpg": 2199,
	"./DSC05000_10_Zuschnitt_Unten_Mobil_1.jpg": 1666,
	"./DSC05000_10_Zuschnitt_Unten_Mobil_2.jpg": 1565,
	"./arrow-left.svg": 7555,
	"./arrow-right.svg": 182,
	"./close.svg": 3608,
	"./menu.svg": 4745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1738;